import React, { isValidElement, useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Tabs as MuiTabs, Tab, CardContent, Card, Grid, Box } from '@mui/material'
import { isUndefined } from 'lodash'
import Action from './action/Action'
import { mainBlue } from 'utils/constants/ColorTheme'

const Tabs = ({
    tabs = [],
    defaultTab = '',
    children = () => {},
}) => {
    const [currentTab, setCurrentTab] = useState(defaultTab)

    useEffect(() => {
        setCurrentTab(defaultTab)
    }, [defaultTab])

    const filteredTabs = tabs.filter(({ displayed = true }) => displayed)

    return (
        <Box>
            <MuiTabs
                value={currentTab}
                onChange={(_, newValue) => setCurrentTab(newValue)}
                variant='fullWidth'
            >
                {filteredTabs.map(({ constant, label, actions = [], disabled = false }) => {
                    const filteredActions = actions.filter(a => a.displayed || isUndefined(a.displayed))
                    return (
                        <Tab
                            key={constant}
                            value={constant}
                            label={(
                                <Grid container justifyContent='space-between' alignItems='center' sx={{ width: '100%' }}>
                                    <Grid size='grow'>
                                        {label}
                                    </Grid>
                                    {filteredActions.length > 0 && constant === currentTab && (
                                        <Grid container size='auto' spacing={0.5} onClick={e => e.stopPropagation()}>
                                            {filteredActions.map(action => (
                                                <Grid key={actions.indexOf(action)} size='auto'>
                                                    {isValidElement(action) ? action : (<Action {...action} color={mainBlue} size='small' />)}
                                                </Grid>
                                            ))}
                                        </Grid>
                                    )}
                                </Grid>
                            )}
                            disabled={disabled}
                        />
                    )
                })}
            </MuiTabs>
            <Card sx={{ borderRadius: '0 0 10px 10px' }}>
                <CardContent>
                    {children(currentTab)}
                </CardContent>
            </Card>
        </Box>
    )
}

Tabs.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.shape({
        constant: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]).isRequired,
        displayed: PropTypes.bool,
        disabled: PropTypes.bool,
        actions: PropTypes.arrayOf(PropTypes.oneOfType([
            PropTypes.element,
            PropTypes.shape({
                icon: PropTypes.string,
                tooltip: PropTypes.oneOfType([
                    PropTypes.string,
                    PropTypes.element,
                ]),
                onClick: PropTypes.func,
                color: PropTypes.string,
                displayed: PropTypes.bool,
                'data-cy': PropTypes.string,
            }),
        ])),
    })).isRequired,
    defaultTab: PropTypes.oneOfType([PropTypes.string, PropTypes.number]), // constant
    children: PropTypes.func.isRequired,
}

export default Tabs